import { Typography } from "@mui/material";

import { T } from "../../../util/t";
import { SpotsLeft } from "./SpotsLeft";

export const EntriesInGroupHeading = ({ divisionName, isTeams, registered, limit, spotsLeft }) =>
    <>
        <Typography variant="h5">{divisionName}</Typography>
        <Typography component="p">
            <T x={registered}>{isTeams ? "x_teams" : "x_athletes"}</T>
            {limit && <SpotsLeft spotsLeft={spotsLeft} includeDash/>}
        </Typography>
    </>;
